
import React, { useEffect, useState } from 'react';
import { FaCheck, FaPlus, FaSave } from 'react-icons/fa';
import { HiOutlineRefresh } from 'react-icons/hi';
import { IoPrint } from 'react-icons/io5';
import { LuView } from 'react-icons/lu';
import { MdEdit } from 'react-icons/md';
import { RiCloseLargeFill } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import Select from 'react-select'

const MatirialIssues = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const user = JSON.parse(sessionStorage.getItem('user'));
    const id = user ? user.id : null;
    console.log(id)

    const [supplierFilter, setSupplierFilter] = useState(null);

    const [currentDate, setCurrentDate] = useState('');


    useEffect(() => {
        const date = new Date();
        const formattedDate = date.toISOString().split('T')[0];
        setCurrentDate(formattedDate);
    }, []);


    const handlePrint = () => {
        console.log('Print functionality');
    };

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleConfirm = () => {
        console.log('Confirm MRN creation');
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setSupplierFilter(null);
        toggleModal();
    };

    const handleApprove = (id) => {

    };
    const handleRefresh = () => {

    };

    const [showEditformm, setShowEditFormm] = useState(false);
    const [showCreateForm, setShowCreateForm] = useState(false);
    const [showViewForm, setShowViewForm] = useState(false);

    const [visibleRows, setVisibleRows] = useState()
    useEffect(() => {
        const totalRows = '';
        const emptyRowsNeeded = totalRows < 4 ? 4 - totalRows : 0;
        setVisibleRows([...'', ...Array(emptyRowsNeeded).fill({})]);
    }, ['']);



    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };
    const [formMode, setFormMode] = useState('');
    const userPermissions = user && user.permissions && user.permissions[1000]
        ? {
            add: user.permissions[2000].sub_ids[2006]?.permissions.add_permission || 0,
            edit: user.permissions[2000].sub_ids[2006]?.permissions.edit_permission || 0,
            view: user.permissions[2000].sub_ids[2006]?.permissions.view_permission || 0,
            save: user.permissions[2000].sub_ids[2006]?.permissions.save_permission || 0,
            approve: user.permissions[2000].sub_ids[2006]?.permissions.approve_permission || 0,
            print: user.permissions[2000].sub_ids[2006]?.permissions.print_permission || 0,
            close: user.permissions[2000].sub_ids[2006]?.permissions.exit_permission || 0,
            clear: user.permissions[2000].sub_ids[2006]?.permissions.refresh_permission || 0
        }
        : {};
    const getButtonState = (permissionType) => {
        switch (formMode) {
            case 'create':
                return permissionType === 'create' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'edit':
                return permissionType === 'edit' || permissionType === 'clear' || permissionType === 'save' || permissionType === 'close';
            case 'view':
                return permissionType === 'view' || permissionType === 'clear' || permissionType === 'close';
            case 'approve':
                return permissionType === 'clear' || permissionType === 'view' || permissionType === 'approve' || permissionType === 'print' || permissionType === 'close';
            default:
                return false;
        }
    };

    const [departments, setDepartments] = useState([]);
    const [locations, setLocations] = useState([]);
    const [items, setItems] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [employee, setEmployee] = useState(false);

    const [formData, setFormData] = useState({
        MR_Dt: new Date().toISOString().split('T')[0],
    });

    const [rows, setRows] = useState(
        Array.from({ length: 10 }, () => ({
            itemCd: '',  itemDesc: '',  itemUOM: '', MR_No: '',
            MR_QTY: '',
            Issue_QTY: ''
        }))
    );

    useEffect(() => {
        axios.get('https://erpapi.emedha.in/pages/api/api/location')
            .then((response) => {
                setLocations(response.data);
            })
            .catch((error) => {
                console.error('Error fetching main groups:', error);
            });

        axios.get('https://erpapi.emedha.in/pages/api/api/depertament')
            .then((response) => {
                setDepartments(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/suppliers')
            .then((response) => {
                setSuppliers(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/itemsmasterform')
            .then((response) => {
                setItems(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
        axios.get('https://erpapi.emedha.in/pages/api/api/employeee')
            .then((response) => {
                setEmployee(response.data);
            })
            .catch((error) => {
                console.error('Error fetching sub groups:', error);
            });
    }, []);

    const [hdrDate, setHdrDate] = useState({
        MI_Dt: new Date().toISOString().split('T')[0],
    });

    const handleSave = async () => {
        if (!hdrDate.MI_Dt || selectedMRs.some(item => !item.testValue)) {
            alert("Please fill in all required fields.");
            return;
        }
        const requestData = {
            hdrData: {
                MI_Dt: hdrDate.MI_Dt,
            },
            dtlData: selectedMRs.map(item => ({
                itemCd: item.Item_code,
                itemDesc: item.Item_description,
                itemUOM: item.UOM,
                MR_No: item.MR_no,
                MR_QTY: item.MR_qty,
                Issue_QTY: item.testValue,
                total_Opening_amt: item.totalOpeningAmount
            })),
        };

        try {
            const response = await axios.post('https://erpapi.emedha.in/pages/api/api/material-Issue', requestData);
            console.log('Success:', response.data);
            alert(`Material Indent saved successfully. MR_No: ${response.data.MI_No}`);
            window.location.reload();
        } catch (error) {
            console.error('Error:', error);
            alert('Error occurred while saving Material Issue');
        }
    };

    const [MRNo, setMRNo] = useState('');
    const [mrNos, setMrNos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMrNos = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/material-indent/mrnos');
                setMrNos(response.data.mrNos);
            } catch (err) {
                setError('Error fetching MR_Nos');
            }
        };
        fetchMrNos();
    }, []);

    const [selectedMRs, setSelectedMRs] = useState([]);
    const [mrList, setMRList] = useState(['']);
    const [miData, setMIData] = useState([]);
    const fetchData = async () => {
        try {
            // Fetch Purchase Order Data (First API)
            const poResponse = await axios.get('https://erpapi.emedha.in/pages/api/api/material-indent');
            console.log("PO API Response:", poResponse.data.data);

            // Fetch MI Data (Second API)
            const miResponse = await axios.get('https://erpapi.emedha.in/pages/api/mi_dtl');
            console.log("MI API Response:", miResponse.data);

            // Storing the MI data
            setMIData(miResponse.data);

            // Creating a map to accumulate Issue_QTY for each MR_No
            const miAccumulated = miResponse.data.reduce((acc, item) => {
                if (!acc[item.MR_No]) {
                    acc[item.MR_No] = 0;
                }
                acc[item.MR_No] += item.Issue_QTY;
                return acc;
            }, {});

            // Processing the Purchase Order Data and calculating the remaining quantity
            const updatedMRList = poResponse.data.data.map(poItem => {
                // Extracting MR_No
                const mrNo = poItem.hdrData.MR_no;

                // Check if there's accumulated Issue_QTY for this MR_No
                const accumulatedIssueQty = miAccumulated[mrNo] || 0;

                // Mapping through dtlData to add remainingQty for each item
                const updatedDtlData = poItem.dtlData.map(item => {
                    // Calculate remaining quantity: Required_qty - Issue_QTY
                    let remainingQty = item.Required_qty;

                    // If there's accumulated Issue_QTY, subtract it from Required_qty
                    remainingQty -= accumulatedIssueQty;

                    // Ensure remainingQty doesn't go below zero
                    remainingQty = Math.max(remainingQty, 0);

                    // Return item with remainingQty
                    return {
                        ...item,
                        remainingQty,  // Add remainingQty to each item
                    };
                });

                // Add updated dtlData with remainingQty and display flag to each PO item
                return {
                    ...poItem,
                    dtlData: updatedDtlData,  // Set updated dtlData with remainingQty
                    display: updatedDtlData.some(item => item.remainingQty > 0), // Display flag based on remainingQty
                };
            });

            // Set filtered PO list to state
            setMRList(updatedMRList.filter(item => item.display));

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);


    const handleCancell = () => {
        setSelectedMRs([]);
        setIsModalOpen(false);
    };

    console.log(mrList)

    const [MI_No, setMINo] = useState('');
    const [miNos, setMiNos] = useState([]);
    const [hdrData, setHdrData] = useState({});
    const [dtlData, setDtlData] = useState([]);

    useEffect(() => {
        const fetchMINos = async () => {
            try {
                const response = await axios.get('https://erpapi.emedha.in/pages/api/api/material-issue/mino');
                console.log(response.data);
                setMiNos(response.data.mrNos);
            } catch (err) {
                setError('Error fetching MI Nos');
            }
        };
        fetchMINos();
    }, []);


    const fetchMIData = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await axios.get(`https://erpapi.emedha.in/pages/api/api/material-issue/${MI_No}`);
            console.log(response.data.data);
            setHdrData(response.data.data.hdrData);
            setDtlData(response.data.data.dtlData);
        } catch (err) {
            setError('Error fetching MI data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!MI_No) return;
        fetchMIData();
    }, [MI_No]);

    const handleMI_NoChange = (selectedOption) => {
        setMINo(selectedOption ? selectedOption.value : '');
    };

    const miOptions = miNos.map((mi) => ({
        value: mi.MI_No,
        label: mi.MI_No,
    }));

    const [success, setSuccess] = useState(false);

    const handleSubmit = async () => {

        setLoading(true);
        setError(null);
        setSuccess(false);

        try {
            const response = await axios.put(`https://erpapi.emedha.in/pages/api/api/material-issue/${MI_No}`, {
                hdrData,
                dtlData
            });

            // Check if response status is 200 (successful)
            if (response.status === 200) {
                // Show success alert with the MR_No
                alert(`Material Issue Update successfully. MR_No: ${response.data.MI_No}`);
                fetchData();
                fetchMIData();
            } else {
                // Handle non-200 status codes if needed
                alert('Something went wrong, please try again.');
            }

            setSuccess(true);
            setLoading(false);
        } catch (err) {
            setError('Error updating data');
            setLoading(false);
        }
    };

    const handleIssueQTYChange = (index, value) => {
        const updatedDtlData = [...dtlData];
        updatedDtlData[index].Issue_QTY = value;  // Update the specific Issue_QTY
        setDtlData(updatedDtlData);  // Set the updated dtlData state
    };
    console.log(selectedMRs)


    const handlePOSelection = (po, item, isChecked) => {
        const selectedItem = {
            Item_code: item.Item_code,
            Item_description: item.Item_description,
            UOM: item.UOM,
            MR_no: po.hdrData.MR_no,
            MR_qty: item.Required_qty,
            remainingQty: item.remainingQty
        };

        if (isChecked) {
            // ✅ Add only this MR_No + Item_code pair uniquely
            setSelectedMRs(prev => {
                const exists = prev.some(
                    sel => sel.MR_no === selectedItem.MR_no && sel.Item_code === selectedItem.Item_code
                );
                if (!exists) return [...prev, selectedItem];
                return prev;
            });
        } else {
            // ✅ Remove ONLY this item of this MR
            setSelectedMRs(prev =>
                prev.filter(
                    sel => !(sel.MR_no === selectedItem.MR_no && sel.Item_code === selectedItem.Item_code)
                )
            );
        }
    };

    const handleInputChange = async (e, index) => {
        const updatedValue = e.target.value;

        // Get the remaining quantity for the item
        const remainingQty = selectedMRs[index].remainingQty; // Assuming remainingQty is available

        // Validate if the input value exceeds the remaining quantity
        if (parseFloat(updatedValue) > remainingQty) {
            alert(`You cannot enter more than the remaining quantity of ${remainingQty}. Please enter a value below.`);
            e.target.value = remainingQty; // Adjust the input to the remaining quantity
            return; // Stop further execution if the input exceeds the remaining quantity
        }

        // Create a new updatedMRs array without changing state yet
        const updatedMRs = [...selectedMRs];
        updatedMRs[index].testValue = updatedValue;

        // Access the item_code before updating state
        const itemCode = updatedMRs[index].Item_code; // Get the item code for the current row

        console.log('this is before response itemCode:', itemCode);
        console.log('this is before response updatedMRs:', updatedMRs);

        // Now make the API call to calculate the total opening amount
        const issuedQty = parseFloat(updatedValue); // Get the issued quantity from the input

        try {
            // Call the backend API to calculate the total opening amount
            const response = await axios.post('https://erpapi.emedha.in/pages/api/calculate-opening-amount', {
                item_code: itemCode,
                issued_qty: issuedQty
            });

            if (response.data.total_opening_amount !== undefined) {
                // Update the totalOpeningAmount for the specific item
                setSelectedMRs(prevState => {
                    const updatedMRs = [...prevState];
                    updatedMRs[index].totalOpeningAmount = response.data.total_opening_amount;

                     const usedQty = response.data.used_qty; // Get the used quantity from backend response

                    const remainingIssuedQty = issuedQty - usedQty; // Calculate how much was wasted
                    if (remainingIssuedQty > 0) {
                        if (usedQty === 0) {
                            alert("No balance available in Opening Balance or MRN. Please create MRN and Opening Balance to proceed.");
                            updatedMRs[index].testValue = "";
                        } else {
                            alert(`You entered ${issuedQty}, but only ${usedQty} could be used. The remaining quantity has been wasted.`);
                            updatedMRs[index].testValue = usedQty;
                        }
                    }
                    return updatedMRs;
                });
            }
        } catch (error) {
            console.error('Error calculating opening amount:', error);
        }
    };


    function formatDateToDateInput(date) {
        const dateObj = new Date(date);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }


        // icons css 

    const iconBox = (enabled) => ({
  width: "48px",
  height: "48px",
  borderRadius: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: enabled ? "linear-gradient(135deg, #ffffff, #f1f5ff)" : "#f0f0f0",
  boxShadow: enabled
    ? "0 4px 10px rgba(0,0,0,0.08)"
    : "none",
  cursor: enabled ? "pointer" : "not-allowed",
  opacity: enabled ? 1 : 0.5,
  transition: "all 0.3s ease",
});

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px 24px",
  borderRadius: "14px",
  background: "linear-gradient(135deg, #e0e7ff, #f8fafc)",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
};

const titleStyle = {
  color: "#1e3a8a",
  fontSize: "2rem",
  fontWeight: "700",
  letterSpacing: "1px",
};

const iconContainer = {
  display: "flex",
  gap: "14px",
  alignItems: "center",
};


    return (
        <div style={{ margin: '0 auto', backgroundColor: '#ffffff', padding: '1rem', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', border: '1px solid black', borderRadius: '10px' }}>
            {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <img src={A1} alt="item" style={{ width: "20%" }} />
                <h1 style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>MATERIAL ISSUES </h1>
                <div style={{ display: "flex", gap: "1rem", cursor: 'pointer' }}>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.add && userPermissions.add !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.add && userPermissions.add !== 0 && getButtonState('create') ? 1 : 0.5
                    }}>
                        <FaPlus size={30} onClick={() => {
                            if (userPermissions.add && userPermissions.add !== 0) {
                                toggleModal();
                                setShowEditFormm(false);
                                setShowCreateForm(true);
                                // setShowViewForm(false);
                                setFormMode('create');
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.edit && userPermissions.edit !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit') ? 1 : 0.5
                    }}>
                        <MdEdit size={30} onClick={() => {
                            if (userPermissions.edit && userPermissions.edit !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(false);
                                setFormMode('edit');
                            } else {
                                alert("You do not have permission to edit.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.view && userPermissions.view !== 0 ? "pointer" : "not-allowed",
                        opacity: userPermissions.view && userPermissions.view !== 0 && getButtonState('view') ? 1 : 0.5
                    }}>
                        <LuView size={30} onClick={() => {
                            if (userPermissions.view && userPermissions.view !== 0) {
                                setShowEditFormm(true);
                                setShowCreateForm(false);
                                // setShowViewForm(true);
                                setFormMode('view');
                            } else {
                                alert("You do not have permission to view.");
                            }
                        }} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? "pointer" : "not-allowed",
                        opacity: userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear') ? 1 : 0.5
                    }}>
                        <HiOutlineRefresh size={30} onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null} />
                    </div>

                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? "pointer" : "not-allowed",
                        opacity: userPermissions.save && userPermissions.save !== 0 && getButtonState('save') ? 1 : 0.5
                    }}>
                        <FaSave size={30} o onClick={() => {
                            //userPermissions.save && userPermissions.save !== 0 ? handleSave : null} />
                            if (userPermissions.save && userPermissions.save !== 0) {
                                if (formMode === 'create') {
                                    handleSave(); // If formMode is approve, use handleApprove
                                } else if (formMode === 'edit') {
                                    handleSubmit(); // If formMode is create or edit, use handleSave
                                }
                            } else {
                                alert("You do not have permission to save.");
                            }
                        }}
                        />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? "pointer" : "not-allowed",
                        opacity: userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve') ? 1 : 0.5
                    }}>
                        <FaCheck size={30} onClick={userPermissions.approve && userPermissions.approve !== 0 ? handleApprove : null} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? "pointer" : "not-allowed",
                        opacity: userPermissions.print && userPermissions.print !== 0 && getButtonState('print') ? 1 : 0.5
                    }} title='Print'>
                        <IoPrint size={30} onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null} />
                    </div>
                    <div style={{
                        width: "40px", height: "40px", backgroundColor: "white", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                        cursor: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? "pointer" : "not-allowed",
                        opacity: userPermissions.close && userPermissions.close !== 0 && getButtonState('close') ? 1 : 0.5
                    }} title='Exit'>
                        <RiCloseLargeFill size={30} onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null} />
                    </div>
                </div>
            </div> */}

            <div style={headerStyle}>
  {/* Logo */}
  <img src={A1} alt="item" style={{ width: "270px", borderRadius: "10px" }} />

  {/* Title */}
  <h1 style={titleStyle}>MATERIAL ISSUES</h1>

  {/* Icons */}
  <div style={iconContainer}>

    {/* Add */}
    <div style={iconBox(userPermissions.add && userPermissions.add !== 0 && getButtonState('create'))}>
      <FaPlus size={20} color="#2563eb"
        onClick={() => {
          if (userPermissions.add && userPermissions.add !== 0) {
            toggleModal();
            setShowEditFormm(false);
            setShowCreateForm(true);
            setFormMode('create');
          }
        }}
      />
    </div>

    {/* Edit */}
    <div style={iconBox(userPermissions.edit && userPermissions.edit !== 0 && getButtonState('edit'))}>
      <MdEdit size={20} color="#f59e0b"
        onClick={() => {
          if (userPermissions.edit && userPermissions.edit !== 0) {
            setShowEditFormm(true);
            setShowCreateForm(false);
            setFormMode('edit');
          } else {
            alert("You do not have permission to edit.");
          }
        }}
      />
    </div>

    {/* View */}
    <div style={iconBox(userPermissions.view && userPermissions.view !== 0 && getButtonState('view'))}>
      <LuView size={20} color="#10b981"
        onClick={() => {
          if (userPermissions.view && userPermissions.view !== 0) {
            setShowEditFormm(true);
            setShowCreateForm(false);
            setFormMode('view');
          } else {
            alert("You do not have permission to view.");
          }
        }}
      />
    </div>

    {/* Refresh */}
    <div style={iconBox(userPermissions.clear && userPermissions.clear !== 0 && getButtonState('clear'))}>
      <HiOutlineRefresh size={20} color="#6366f1"
        onClick={userPermissions.clear && userPermissions.clear !== 0 ? handleRefresh : null}
      />
    </div>

    {/* Save */}
    <div style={iconBox(userPermissions.save && userPermissions.save !== 0 && getButtonState('save'))}>
      <FaSave size={20} color="#22c55e"
        onClick={() => {
          if (userPermissions.save && userPermissions.save !== 0) {
            if (formMode === 'create') {
              handleSave();
            } else if (formMode === 'edit') {
              handleSubmit();
            }
          } else {
            alert("You do not have permission to save.");
          }
        }}
      />
    </div>

    {/* Approve */}
    <div style={iconBox(userPermissions.approve && userPermissions.approve !== 0 && getButtonState('approve'))}>
      <FaCheck size={20} color="#16a34a"
        onClick={userPermissions.approve && userPermissions.approve !== 0 ? handleApprove : null}
      />
    </div>

    {/* Print */}
    <div style={iconBox(userPermissions.print && userPermissions.print !== 0 && getButtonState('print'))}>
      <IoPrint size={20} color="#0ea5e9"
        onClick={userPermissions.print && userPermissions.print !== 0 ? handlePrint : null}
      />
    </div>

    {/* Close */}
    <div style={iconBox(userPermissions.close && userPermissions.close !== 0 && getButtonState('close'))}>
      <RiCloseLargeFill size={20} color="#ef4444"
        onClick={userPermissions.close && userPermissions.close !== 0 ? handleBack : null}
      />
    </div>

  </div>
</div>
            <hr />

               {!showCreateForm && !showEditformm && !showViewForm && (
                    <div
                        style={{
                            marginTop: "20px",
                            border: "2px dashed #cbd5e1",
                            borderRadius: "16px",
                            height: "320px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "linear-gradient(135deg, #f8fafc, #f1f5f9)",
                            boxShadow: "inset 0 2px 8px rgba(0,0,0,0.05)",
                        }}
                    >
                        <div style={{ textAlign: "center", color: "#64748b" }}>

                            {/* Icon */}
                            <div
                                style={{
                                    fontSize: "48px",
                                    marginBottom: "10px",
                                    opacity: 0.6,
                                }}
                            >
                                📦
                            </div>

                            {/* Text */}
                            <h2
                                style={{
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    color: "#475569",
                                }}
                            >
                                Select an action from the header to begin
                            </h2>
                        </div>
                    </div>
                )}

            {showCreateForm && (

                <>
                    {isModalOpen && (
                        <div style={{ position: 'fixed', top: '0', left: '0', right: '0', bottom: '0', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <div style={{ backgroundColor: '#ffffff', padding: '16px', borderRadius: '8px', width: '80%' }}>
                                <h4 className='text-center'>PENDING MATERIAL REQUEST</h4>
                                <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>MR_No</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>MR_DT</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>ITEM</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>ITEM_DESC</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>UOM</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>MR_QTY</th>
                                            <th style={{ width: '50px', border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>RemainingMR_qty</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue' }}>Selection</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(mrList) && mrList.map((po) => (
                                            po.dtlData && Array.isArray(po.dtlData) && po.dtlData.map((item) => (
                                                <tr key={item.Sl_no}>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{po.hdrData.MR_no}</td>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{new Date(po.hdrData.MR_Dt).toLocaleDateString('en-GB')}</td>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{item.Item_code}</td>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{item.Item_description}</td>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{item.UOM}</td>
                                                    <td style={{ minWidth: '90px', border: '1px solid black', padding: '8px' }}>{item.Required_qty}</td>
                                                    <td style={{ minWidth: '30px', border: '1px solid black', padding: '8px' }}>{item.remainingQty}</td>
                                                    <td style={{ border: '1px solid black', padding: '8px' }}><input type="checkbox" onChange={(e) => handlePOSelection(po, item, e.target.checked)} /></td>
                                                </tr>
                                            ))
                                        ))}
                                    </tbody>
                                </table>
                                <div style={{ marginTop: '16px' }}>
                                    <button style={{ backgroundColor: "blue", color: 'white', padding: '2px 20px', borderRadius: '4px', marginRight: '10px', cursor: 'pointer' }} onClick={handleConfirm}>Confirm</button>
                                    <button style={{ backgroundColor: "blue", color: 'white', padding: '2px 20px', borderRadius: '4px', marginRight: '10px', cursor: 'pointer' }} onClick={handleCancell}>Cancel</button>
                                </div>
                            </div>
                        </div>

                    )}

                    {selectedMRs.length > 0 && (
                        <div>
                            <div className='p-1' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '156px' }}>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '23px', color: 'darkblue' }}>MRN No:</label>
                                        <input readOnly style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                                    </div>
                                </div>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}><label style={{ marginRight: '40px', color: 'darkblue' }}>MRN Dt:</label>
                                        <input type='date' value={currentDate} onChange={(e) => { setCurrentDate(e.target.value); setHdrDate({ ...hdrDate, MI_Dt: e.target.value }); }} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '50%', outline: 'none', backgroundColor: 'transparent' }} />
                                    </div>
                                </div>
                            </div>
                            <div style={{ overflowY: 'auto', height: '350px' }}>
                                <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>SI.No</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>ITEM</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>ITEM_DESC</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>UOM</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>MR_No</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>MR_QTY</th>

                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>Remaining MR_QTY</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>Issued Qty</th>

                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedMRs.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.Item_code}</td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.Item_description}</td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.UOM}</td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.MR_no}</td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.MR_qty}</td>

                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>{item.remainingQty}</td>
                                                <td style={{ minWidth: '90px', border: '1px solid black', padding: '4px', textAlign: 'center' }}>
                                                    <input type="text" value={item.testValue} maxLength={12}
                                                        onChange={(e) => {
                                                            const inputValue = e.target.value;
                                                            const remainingQty = item.remainingQty; // Get the remaining quantity
                                                            // let numericValue = parseFloat(inputValue);

                                                            // if (isNaN(numericValue)) {
                                                            //     return; // Do nothing if it's not a number
                                                            // }

                                                            if (inputValue.includes('.')) {
                                                                let parts = inputValue.split('.');
                                                                if (parts[1] && parts[1].length > 2) {

                                                                    e.target.value = parts[0] + '.' + parts[1].slice(0, 2);
                                                                    return; // Prevent input beyond 2 decimal places
                                                                }
                                                            }
                                                            
                                                            if (parseFloat(inputValue) > remainingQty) {
                                                                alert(`You cannot enter more than the remaining quantity of ${remainingQty}.`);
                                                                e.target.value = "";  // Clear the input if the value exceeds the remaining quantity
                                                                return; // Prevent further input
                                                            }
                                                            handleInputChange(e, index)

                                                        }} style={{ textAlign: 'center', width: '150px', border: 'black', outline: 'black', backgroundColor: 'transparent' }} />
                                                </td>
                                                <td id="calculated-amount" style={{ minWidth: '90px', border: '1px solid black', padding: '4px', textAlign: 'center' }}>
                                                    {item.totalOpeningAmount || 0}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </>
            )}
            <>
                {showEditformm && (
                    <>
                        <div>
                            <div className="p-1" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '156px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <label style={{ marginRight: '23px', color: 'darkblue' }}>MI.No:</label>
                                   
                                    <Select
                                        value={miOptions.find((option) => option.value === MI_No)}
                                        onChange={handleMI_NoChange}
                                        options={miOptions}
                                        placeholder="Select MI No"
                                        styles={{
                                            container: (provided) => ({ ...provided, width: '100%', padding: '6px' }),
                                            menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
                                            menu: (provided) => ({ ...provided, width: '80%', maxHeight: '100px', overflowY: 'auto' }),
                                            control: (provided) => ({ ...provided, backgroundColor: 'transparent', height: '35px' }),
                                            singleValue: (provided) => ({ ...provided, color: 'black' }),
                                        }}
                                    />
                                </div>

                                <div>
                                 
                                    <div style={{ display: 'flex', alignItems: 'center' }}>


                                        {formMode === 'view' ? (
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '40px', color: 'darkblue' }}>MI Dt:</label>
                                                <input type="date" readOnly value={hdrData.MI_Dt ? formatDateToDateInput(hdrData.MI_Dt) : ''} onChange={(e) => { setHdrData({ ...hdrData, MI_Dt: e.target.value }); }} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '60%', outline: 'none', backgroundColor: 'transparent' }} />
                                            </div>


                                        ) : (

                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <label style={{ marginRight: '40px', color: 'darkblue' }}>MI Dt:</label>
                                                <input type="date" value={hdrData.MI_Dt ? formatDateToDateInput(hdrData.MI_Dt) : ''} onChange={(e) => { setHdrData({ ...hdrData, MI_Dt: e.target.value }); }} style={{ border: 'none', borderLeft: '2px solid #D1D5DB', padding: '10px', width: '55%', outline: 'none', backgroundColor: 'transparent' }} />
                                            </div>

                                        )}
                                    </div>

                                </div>
                            </div>

                            <div style={{ overflowY: 'auto', maxHeight: '350px' }}>
                                <table style={{ minWidth: '100%', borderCollapse: 'collapse', border: '1px solid black' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>MI_NO</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>ITEM</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>ITEM_DESC</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>UOM</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>MR_No</th>
                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>MR_QTY</th>

                                            <th style={{ border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>Issued Qty</th>
                                            <th style={{ minWidth: '90px', border: '1px solid black', textAlign: 'center', color: 'darkblue', padding: '8px' }}>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[...dtlData, ...new Array(10 - dtlData.length).fill({})].slice(0, 10).map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.Sl_no || ''}
                                                </td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.Item_code || ''}
                                                </td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.Item_description || ''}
                                                </td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.UOM || ''}
                                                </td>

                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.MR_No || ''}
                                                </td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.MR_QTY || ''}
                                                </td>
                                               
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {formMode === 'view' ? (
                                                        <input
                                                            type="text"
                                                            value={item.Issue_QTY || ''}
                                                            maxLength={12}
                                                            onChange={(e) => { }}
                                                            style={{ textAlign: 'center', width: '100%', border: 'black', padding: '4px', outline: 'black', backgroundColor: 'transparent' }}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            value={item.Issue_QTY || ''}
                                                            maxLength={12}
                                                            onChange={(e) => handleIssueQTYChange(index, e.target.value)}
                                                            style={{ textAlign: 'center', width: '100%', border: 'black', padding: '4px', outline: 'black', backgroundColor: 'transparent' }}
                                                        />
                                                    )}
                                                </td>
                                                <td style={{ border: '1px solid black', padding: '4px', textAlign: 'center', width: '14%' }}>
                                                    {item.total_Opening_amt || ''}</td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </>
                )}

            </>



        </div>
    );
};

export default MatirialIssues;



